import React, { useState } from 'react';
import { ConfirmPoiSave } from "@components/maps/modals/pois/poiDialogComponents/ConfirmPoiSave"

/**
 * Function and dialog box to confirm actions throughout app
 * 
 * @returns {JSX.Element} ConfirmDialog - dialog box component
 * @returns {function} requestConfirm - opens the modal, handles state changes, returns promise ("Yes", "No", or "Cancel")
 * 
 * @category Hooks
 */
const useConfirmPoiSave = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [confirmButtonText, setConfirmButtonText] = useState("Yes");
    const [noButtonText, setNoButtonText] = useState("No");
    const [cancelButtonText, setCancelButtonText] = useState("Cancel"); 
    const [resolve, setResolve] = useState(null); 

    const requestConfirm = (customMessage, confirmText = "Yes", noText = "No", cancelText = "Cancel") => {
        setIsOpen(true);
        setMessage(customMessage);
        setConfirmButtonText(confirmText);
        setNoButtonText(noText);
        setCancelButtonText(cancelText);

        return new Promise((resolve) => {
            setResolve(() => resolve);
        });
    };

    const handleConfirm = () => {
        resolve("Yes");
        setIsOpen(false);
    };

    const handleNo = () => {
        resolve("No");
        setIsOpen(false);
    };

    const handleCancel = () => {
        resolve("Cancel");
        setIsOpen(false);
    };

    const ConfirmDialog = () => {
        return (
            <ConfirmPoiSave
                showModal={isOpen} 
                message={message}
                handleConfirm={handleConfirm} 
                handleNo={handleNo}
                handleThirdOption={handleCancel}
                confirmButtonText={confirmButtonText}
                noButtonText={noButtonText}
                thirdOptionText={cancelButtonText} 
            />
        );
    };

    return [ConfirmDialog, requestConfirm];
};

export default useConfirmPoiSave;
